import { whenever } from '@vueuse/core'
import type { WatchCallback } from 'vue'

export function onKeyPress (
  keyRef: ComputedRef<boolean>,
  fn: WatchCallback<true>,
  enabled: () => boolean = () => (true),
) {
  return whenever(() => enabled() && keyRef.value, fn)
}
